export default __webpack_public_path__ + "static/media/hero-right-side-view0.8e2f425b.webp";